$(function(){
  $('.testimonial-slider-wrapper').slick({
  	slidesToShow: 1,
  	// autoplay: true,
  	arrows: true,
  	dots: true,
  	prevArrow: '.testimonial-slide-prev',
  	nextArrow: '.testimonial-slide-next',
  	// appendArrows: '.testimonial-slider-arrows',
  	appendDots: '.testimonial-slider-dots'
  });

  /* filters in collection page */
  $('.filters__filter-link').click(function(e) {
  	$(this).toggleClass('active');
  	refreshProducts();
  });
  $('.filters__reset').click(function(e) {
  	$('.filters__filter-link').removeClass('active');
  	refreshProducts();
  });
  $('.filters__toggle').click(function(e) {
  	$('.filters__reset').toggleClass('active');
  	$('.filters__content').toggleClass('active');
  });


  /* description in product page */
  $('.product-single__description-tab').click(function(e) {
  	let $tab = $(this);
  	let $content = $('.product-single__description-content[data-index=' + $tab.attr('data-index') + ']');
  	$tab.siblings().removeClass('active');
  	$tab.addClass('active');
  	$content.siblings().removeClass('active');
  	$content.addClass('active');
  	/*setTimeout(function() {
  		$content.addClass('active');
  	}, 300);*/
  });

  /* update qty in cart page */
  $('.cart__qty-select').change(function(e) {
  	let $item = $(this).closest('.cart__row');
  	$item.find('.cart__qty-input').val($(this).val());
  });
});

function refreshProducts() {
	let active_filters = [];
	$('.filters__filter-link').each(function(i, link) {
		if ($(link).hasClass('active')) {
			active_filters.push($(link).attr('data-filter'));
		}
	});
	if (active_filters.length == 0) {
		$('.collection-products .grid__item').show();
		return;
	}
	$('.collection-products .grid__item').each(function(i, item) {
		let tags = $(item).attr('data-tags');
		let filtered = false;
		active_filters.forEach(function(filter) {
			if (tags.indexOf(filter) >= 0) filtered = true;
		});
		if (filtered) {
			$(item).show();
		} else {
			$(item).hide();
		}
	});
}

(function initFilters() {
	const url_params = new URLSearchParams(window.location.search);
	const grades = url_params.get('grade') ? url_params.get('grade').split(',') : [];
	const operations = url_params.get('operation') ? url_params.get('operation').split(',') : [];
	grades.forEach(function(grade) {
		$('.filters__filter-link').filter('[data-filter="' + grade + '"]').addClass('active');
	});
	operations.forEach(function(operation) {
		$('.filters__filter-link').filter('[data-filter="' + operation + '"]').addClass('active');
	});
	refreshProducts();
})();

(function initOverview() {
	var $rte = $('.collection-header .rte');
	var $overview = $('.collection-header .rte strong');
	if (!$overview.length) return;
	if (window.innerWidth < 1200) {
		$rte.css('max-height', $overview.offset().top - $rte.offset().top + $overview.height() + 'px');
	}
	
	$overview.on('click', function(e) {
		if (window.innerWidth >= 1200) {
			$overview.text('Overview');
			return;
		}
		// if (!$rte.hasClass('open') && $rte.css('max-height') == 'none') return;
		$rte.toggleClass('open');
		if ($rte.hasClass('open')) {
			$overview.text('Hide Overview');
			var $rte_clone = $rte.clone().appendTo('body');
			var full_height = $rte_clone.css('max-height', 'none').height();
			$rte_clone.remove();
			$rte.css('max-height', full_height + 'px');
		} else {
			$overview.text('Overview');
			$rte.css('max-height', $overview.offset().top - $rte.offset().top + $overview.height() + 'px');
		}
	});
})();
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}